export default {
  ACCESS_COMMANDER_REMOTE: 'ACCESS_COMMANDER_REMOTE',
  DORMAKABA: 'DORMAKABA',
  DORMAKABA_PAYMENTS: 'DORMAKABA_PAYMENTS',
  ELEVATOR_INTEGRATIONS_APPARTMENT_CALL: 'ELEVATOR_INTEGRATIONS_APPARTMENT_CALL',
  GUEST_ACCESS: 'GUEST_ACCESS',
  HEG_MAINTENANCE: 'HEG_MAINTENANCE',
  ORY_REGISTRATION: 'ORY_REGISTRATION',
  USER_BLE_CREDENTIAL: 'USER_BLE_CREDENTIAL',
};
